import Crud from '../views/PosicaoVeiculo/Crud'
import Entity from '../views/PosicaoVeiculo/Add'

let routes = {
    path: '/posicao_veiculo',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/posicao_veiculo/add',
            name: 'NewPosicaoVeiculo',
            component: Entity
        },
        {
            path: '/posicao_veiculo/edit/:id?',
            name: 'EditPosicaoVeiculo',
            component: Entity
        },
        {
            path: '/posicao_veiculo',
            name: 'list-posicao-veiculo',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Posições Veículos',
                breadcrumb: [
                    {
                        text: 'Posições Veículos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
